export default __webpack_public_path__ + "static/media/pt-icon.dba72d40.svg";